import { Component, OnInit, Input, ViewChild } from '@angular/core';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take, map } from 'rxjs/operators';
import { LotePresupuestoService } from 'src/app/services/lote-presupuesto.service';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import Chart from 'chart.js';
import { LotePresupuestoEstado } from 'src/app/models/entities/lote-presupuesto-estado';
import { trigger, state, style, transition, animate } from '@angular/animations';

interface EstadoPresupuesto {
  clave: string;
  nombreEstado: string;
  modificado: number;
  totalEjercido: number;
  subEjercicio: number;
  calendarizado: number;
}

@Component({
  selector: 'grafica-barras-prep-estados',
  templateUrl: './grafica-barras-prep-estados.component.html',
  styleUrls: ['./grafica-barras-prep-estados.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class GraficaBarrasPrepEstadosComponent implements OnInit {

  @ViewChild('modalDetallePresupuestoEstado')
  public modalDetallePresupuestoEstado: any;
  public plugin = ChartDataLabels;
  public options: any;
  public data: any;
  public catUnidadesResponsables: UnidadResponsable[] = [];
  public estadosPresupuestosUnidos: EstadoPresupuesto[] = [];
  public estadoPresupuestoSeleccionado: EstadoPresupuesto;
  public estadosPresupuestosRurales: EstadoPresupuesto[] = [];
  public estadosPresupuestosFederales: EstadoPresupuesto[] = [];
  public ruralesSeleccionado: boolean = true;
  public federalesSeleccionado: boolean = true;

  constructor(
    private catalogoService: CatalogoService,
    private lotePresupuestoService: LotePresupuestoService
  ) { }

  async ngOnInit() {
    await this.obtenerCatalogos();
    this.cargarConfigGrafica();
    this.estadosPresupuestosRurales = await this.cargarPresupuestosRuralesEstados();
    this.estadosPresupuestosFederales = await this.cargarPresupuestosFederalesEstados();
    this.estadosPresupuestosUnidos = this.unirPresupuestos(this.estadosPresupuestosRurales, this.estadosPresupuestosFederales);
    this.cargarDatos(this.estadosPresupuestosUnidos);
  }


  public cambioCheckBox(valor: boolean, ruralesSeleccionado: boolean, federalesSeleccionado: boolean): void {
    if (ruralesSeleccionado && federalesSeleccionado) {
      this.cargarDatos(this.estadosPresupuestosUnidos);
    } else if (ruralesSeleccionado && federalesSeleccionado === false) {
      this.cargarDatos(this.estadosPresupuestosRurales);
    } else if (ruralesSeleccionado === false && federalesSeleccionado) {
      this.cargarDatos(this.estadosPresupuestosFederales);
    } else {
      this.cargarDatos([]);
    }

  }

  public cargarDatos(presupuestos: EstadoPresupuesto[]) {
    this.data = {
      labels: presupuestos.map((ep: EstadoPresupuesto) => ep.nombreEstado),
      datasets: [
        {
          label: 'Modificado',
          data: presupuestos.map((ep: EstadoPresupuesto) => parseFloat(ep.modificado.toFixed(2))),
          backgroundColor: '#4371c2',
          borderColor: '#4371c2'
        },
        {
          label: 'Ejercido total',
          data: presupuestos.map((ep: EstadoPresupuesto) => parseFloat(ep.subEjercicio.toFixed(2))),
          backgroundColor: '#09b03b',
          borderColor: '#09b03b'
        },
        {
          label: 'Saldo',
          data: presupuestos.map((ep: EstadoPresupuesto) => parseFloat(ep.totalEjercido.toFixed(2))),
          backgroundColor: '#e80000',
          borderColor: '#e80000'
        },
        {
          label: 'Calendarizado',
          data: presupuestos.map((ep: EstadoPresupuesto) => parseFloat(ep.calendarizado.toFixed(2))),
          backgroundColor: '#eb7c30',
          borderColor: '#eb7c30'
        }
      ]
    };
  }

  public unirPresupuestos(rurales: EstadoPresupuesto[], federales: EstadoPresupuesto[]) {
    let edosPresupuestos: EstadoPresupuesto[] = []
    this.catUnidadesResponsables.forEach((ur: UnidadResponsable) => {
      let presupuestoRuralEncontrado: EstadoPresupuesto = rurales.find((ep: EstadoPresupuesto) => ep.nombreEstado === ur.nombreEstado);
      let presupuestoFederalEncontrado: EstadoPresupuesto = federales.find((ep: EstadoPresupuesto) => ep.nombreEstado === ur.nombreEstado);
      if (presupuestoRuralEncontrado && presupuestoFederalEncontrado) {
        let presupuestoEstado: EstadoPresupuesto = {
          clave: presupuestoRuralEncontrado.clave,
          nombreEstado: presupuestoRuralEncontrado.nombreEstado,
          modificado: presupuestoRuralEncontrado.modificado + presupuestoFederalEncontrado.modificado,
          subEjercicio: presupuestoRuralEncontrado.subEjercicio + presupuestoFederalEncontrado.subEjercicio,
          totalEjercido: presupuestoRuralEncontrado.totalEjercido + presupuestoFederalEncontrado.totalEjercido,
          calendarizado: presupuestoRuralEncontrado.calendarizado + presupuestoFederalEncontrado.calendarizado
        };
        edosPresupuestos.push(presupuestoEstado);
      } else if (presupuestoRuralEncontrado && presupuestoFederalEncontrado === undefined) {
        let presupuestoEstado: EstadoPresupuesto = {
          clave: presupuestoRuralEncontrado.clave,
          nombreEstado: presupuestoRuralEncontrado.nombreEstado,
          modificado: presupuestoRuralEncontrado.modificado,
          subEjercicio: presupuestoRuralEncontrado.subEjercicio,
          totalEjercido: presupuestoRuralEncontrado.totalEjercido,
          calendarizado: presupuestoRuralEncontrado.calendarizado
        };
        edosPresupuestos.push(presupuestoEstado);
      } else if (presupuestoRuralEncontrado === undefined && presupuestoFederalEncontrado) {
        let presupuestoEstado: EstadoPresupuesto = {
          clave: presupuestoFederalEncontrado.clave,
          nombreEstado: presupuestoFederalEncontrado.nombreEstado,
          modificado: presupuestoFederalEncontrado.modificado,
          subEjercicio: presupuestoFederalEncontrado.subEjercicio,
          totalEjercido: presupuestoFederalEncontrado.totalEjercido,
          calendarizado: presupuestoFederalEncontrado.calendarizado
        };
        edosPresupuestos.push(presupuestoEstado);
      }
    });
    return edosPresupuestos;
  }

  public async cargarPresupuestosRuralesEstados(): Promise<EstadoPresupuesto[]> {
    return this.lotePresupuestoService.findByKeyCatDireccion('0').pipe(
      take(1),
      map((lotePresupuesto: LotePresupuesto) => {
        let clavesUnidadesResponsables: string[] = [];
        clavesUnidadesResponsables = lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.map((presupuestoEstado: PresupuestoEstado) => presupuestoEstado.ur);
        let clavesUnidadesResponsablesSinRepetir: string[] = (Array.from(new Set<string>(clavesUnidadesResponsables)));
        return clavesUnidadesResponsablesSinRepetir.map((ur: string) => {
          let modificado: number = 0;
          let totalEjercido: number = 0;
          let subEjercicio: number = 0;
          let calendarizado: number = 0;
          lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.filter((pe: PresupuestoEstado) => pe.ur === ur).forEach((pe: PresupuestoEstado) => {
            modificado += pe.modificadoSia;
            totalEjercido += pe.totalEjercido;
            subEjercicio += pe.calendarioVsTotalEjercido;
            calendarizado += pe.calendario
          });
          return {
            clave: ur,
            nombreEstado: this.catUnidadesResponsables.find((unidadResp: UnidadResponsable) => unidadResp.cve.toString() === ur).nombreEstado,
            modificado,
            totalEjercido,
            subEjercicio,
            calendarizado
          } as EstadoPresupuesto
        })
      })
    ).toPromise();
  }

  public async cargarPresupuestosFederalesEstados(): Promise<EstadoPresupuesto[]> {
    return this.lotePresupuestoService.findByKeyCatDireccion('1').pipe(
      take(1),
      map((lotePresupuesto: LotePresupuesto) => {
        let clavesUnidadesResponsables: string[] = [];
        clavesUnidadesResponsables = lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.map((presupuestoEstado: PresupuestoEstado) => presupuestoEstado.ur);
        let clavesUnidadesResponsablesSinRepetir: string[] = (Array.from(new Set<string>(clavesUnidadesResponsables)));
        return clavesUnidadesResponsablesSinRepetir.map((ur: string) => {
          let modificado: number = 0;
          let totalEjercido: number = 0;
          let subEjercicio: number = 0;
          let calendarizado: number = 0;
          lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.filter((pe: PresupuestoEstado) => pe.ur === ur).forEach((pe: PresupuestoEstado) => {
            modificado += pe.modificadoSia;
            totalEjercido += pe.totalEjercido;
            subEjercicio += pe.calendarioVsTotalEjercido;
            calendarizado += pe.calendario
          });
          return {
            clave: ur,
            nombreEstado: this.catUnidadesResponsables.find((unidadResp: UnidadResponsable) => unidadResp.cve.toString() === ur).nombreEstado,
            modificado,
            totalEjercido,
            subEjercicio,
            calendarizado
          } as EstadoPresupuesto
        })
      })
    ).toPromise();
  }

  public cargarConfigGrafica() {
    this.options = {
      plugins: {
        datalabels: {
          display: false
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: function (value, index, values) {
              return '$' + value;
            }
          },
          scaleLabel: {
            display: true,
            labelString: 'Millones de pesos'
          }
        }]
      },
      layout: {
        padding: {
          top: 10
        }
      },
      legend: {
        position: 'bottom'
      },

      tooltips: {
        intersect: true,
        callbacks: {
          label: function (tooltipItem, data) {
            let label = data.datasets[tooltipItem.datasetIndex].label || '';
            return label + " $" + tooltipItem.yLabel + " Clic para ver detalle";
          }
        }
      },
      elements: {
        line: {
          tension: 0
        }
      }
    };
  }
  public async obtenerCatalogos(): Promise<void> {
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
  }

  public selectData(event: any): void {
    if (this.ruralesSeleccionado && this.federalesSeleccionado) {
      this.estadoPresupuestoSeleccionado = { ...this.estadosPresupuestosUnidos[(event.element._index)] };
    } else if (this.ruralesSeleccionado && this.federalesSeleccionado === false) {
      this.estadoPresupuestoSeleccionado = { ...this.estadosPresupuestosRurales[(event.element._index)] };
    } else if (this.ruralesSeleccionado === false && this.federalesSeleccionado) {
      this.estadoPresupuestoSeleccionado = { ...this.estadosPresupuestosFederales[(event.element._index)] };
    }
    this.estadoPresupuestoSeleccionado.modificado = parseFloat(this.estadoPresupuestoSeleccionado.modificado.toFixed(2));
    this.estadoPresupuestoSeleccionado.totalEjercido = parseFloat(this.estadoPresupuestoSeleccionado.totalEjercido.toFixed(2));
    this.estadoPresupuestoSeleccionado.subEjercicio = parseFloat(this.estadoPresupuestoSeleccionado.subEjercicio.toFixed(2));
    this.modalDetallePresupuestoEstado.abrirModal(this.ruralesSeleccionado, this.federalesSeleccionado);
  }

}
